import { PlanPreviewList } from "./plan-preview-list";

export const PlanPreview = () => {
  return <PlanPreviewList />;
};
